

export default {
  locale: 'sr',
  Pagination: {
    items_per_page: '/ strani',
    jump_to: 'Idi na',
    page: '',
    prev_page: 'Prethodna strana',
    next_page: 'Sledeća strana',
    prev_5: 'Prethodnih 5 Strana',
    next_5: 'Sledećih 5 Strana',
    prev_3: 'Prethodnih 3 Strane',
    next_3: 'Sledećih 3 Strane',
    page_size: 'Page Size'
  },
  DatePicker: {
    lang: {
      placeholder: 'Izaberi datum',
      rangePlaceholder: ['Datum početka', 'Datum završetka'],
      locale: 'sr_RS',
      today: 'Danas',
      now: 'Sada',
      backToToday: 'Vrati se na danas',
      ok: 'U redu',
      clear: 'Obriši',
      month: 'Mesec',
      year: 'Godina',
      timeSelect: 'Izaberi vreme',
      dateSelect: 'Izaberi datum',
      monthSelect: 'Izaberi mesec',
      yearSelect: 'Izaberi godinu',
      decadeSelect: 'Izaberi deceniju',
      yearFormat: 'YYYY',
      dateFormat: 'DD.MM.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Prethodni mesec (PageUp)',
      nextMonth: 'Sledeći mesec (PageDown)',
      previousYear: 'Prethodna godina (Control + left)',
      nextYear: 'Sledeća godina (Control + right)',
      previousDecade: 'Prethodna decenija',
      nextDecade: 'Sledeća decenija',
      previousCentury: 'Prethodni vek',
      nextCentury: 'Sledeći vek',
      yearPlaceholder: 'Izaberi godinu',
      quarterPlaceholder: 'Izaberi tromesečje',
      monthPlaceholder: 'Izaberi mesec',
      weekPlaceholder: 'Izaberi sedmicu',
      rangeYearPlaceholder: ['Godina početka', 'Godina završetka'],
      rangeMonthPlaceholder: ['Mesec početka', 'Mesec završetka'],
      rangeWeekPlaceholder: ['Sedmica početka', 'Sedmica završetka']
    },
    timePickerLocale: {
      placeholder: 'Izaberi vreme',
      rangePlaceholder: ['Vreme početka', 'Vreme završetka']
    }
  },
  TimePicker: {
    placeholder: 'Izaberi vreme',
    rangePlaceholder: ['Vreme početka', 'Vreme završetka']
  },
  Calendar: {
    lang: {
      placeholder: 'Izaberi datum',
      rangePlaceholder: ['Datum početka', 'Datum završetka'],
      locale: 'sr_RS',
      today: 'Danas',
      now: 'Sada',
      backToToday: 'Vrati se na danas',
      ok: 'U redu',
      clear: 'Obriši',
      month: 'Mesec',
      year: 'Godina',
      timeSelect: 'Izaberi vreme',
      dateSelect: 'Izaberi datum',
      monthSelect: 'Izaberi mesec',
      yearSelect: 'Izaberi godinu',
      decadeSelect: 'Izaberi deceniju',
      yearFormat: 'YYYY',
      dateFormat: 'DD.MM.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Prethodni mesec (PageUp)',
      nextMonth: 'Sledeći mesec (PageDown)',
      previousYear: 'Prethodna godina (Control + left)',
      nextYear: 'Sledeća godina (Control + right)',
      previousDecade: 'Prethodna decenija',
      nextDecade: 'Sledeća decenija',
      previousCentury: 'Prethodni vek',
      nextCentury: 'Sledeći vek',
      yearPlaceholder: 'Izaberi godinu',
      quarterPlaceholder: 'Izaberi tromesečje',
      monthPlaceholder: 'Izaberi mesec',
      weekPlaceholder: 'Izaberi sedmicu',
      rangeYearPlaceholder: ['Godina početka', 'Godina završetka'],
      rangeMonthPlaceholder: ['Mesec početka', 'Mesec završetka'],
      rangeWeekPlaceholder: ['Sedmica početka', 'Sedmica završetka']
    },
    timePickerLocale: {
      placeholder: 'Izaberi vreme',
      rangePlaceholder: ['Vreme početka', 'Vreme završetka']
    }
  },
  Table: {
    filterTitle: 'Meni filtera',
    filterConfirm: 'U redu',
    filterReset: 'Poništi',
    selectAll: 'Izaberi trenutnu stranicu',
    selectInvert: 'Obrni izbor trenutne stranice',
    filterEmptyText: 'Nema filtera',
    emptyText: 'Nema podataka',
    selectNone: 'Obriši sve podatke',
    selectionAll: 'Izaberi sve podatke',
    sortTitle: 'Sortiraj',
    expand: 'Proširi red',
    collapse: 'Skupi red',
    triggerDesc: 'Klikni da sortiraš po padajućem redosledu',
    triggerAsc: 'Klikni da sortiraš po rastućem redosledu',
    cancelSort: 'Klikni da otkažeš sortiranje'
  },
  Modal: {
    okText: 'U redu',
    cancelText: 'Otkaži',
    justOkText: 'U redu'
  },
  Popconfirm: {
    okText: 'U redu',
    cancelText: 'Otkaži'
  },
  Transfer: {
    searchPlaceholder: 'Pretraži ovde',
    itemUnit: 'stavka',
    itemsUnit: 'stavki',
    titles: ['', ''],
    remove: 'Ukloni',
    selectCurrent: 'Izaberi trenutnu stranicu',
    removeCurrent: 'Ukloni trenutnu stranicu',
    selectAll: 'Izaberi sve podatke',
    removeAll: 'Ukloni sve podatke',
    selectInvert: 'Obrni izbor trenutne stranice'
  },
  Upload: {
    uploading: 'Otpremanje...',
    removeFile: 'Ukloni datoteku',
    uploadError: 'Greška pri otpremanju',
    previewFile: 'Pregledaj datoteku',
    downloadFile: 'Preuzmi datoteku'
  },
  Empty: {
    description: 'Nema podataka'
  },
  global: {
    placeholder: 'Izaberi'
  },
  Icon: {
    icon: 'ikona'
  },
  Text: {
    edit: 'Uredi',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    expand: 'Proširi'
  },
  PageHeader: {
    back: 'Nazad'
  },
  Image: {
    preview: 'Pregled'
  }
};
